// Shared brand assets / constants used across components.

export const ASSETS = {
  foundationLogo:
    "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/69q8cxb3_SJM%20New%20Logo.png",
  summerDiscoveryLogo:
    "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/nhc1txy1_Summer%20Works.png",
  flyerFront:
    "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/c2iq7drw_Flyers.jpg",
  flyerBack:
    "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/mzzau7jn_BACK%20Flyers.jpg",
  // Semaj in action — real event photos
  action: {
    michiganInfluence:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/emnbeehh_Michigan%20influence.jpg",
    event1: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/p8sjin4a_IMG_4062.jpg",
    event2: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/jzinpcp5_IMG_4128.JPG",
    event3: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/0junur64_IMG_4146.JPG",
    event4: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/13d556z1_IMG_4155.JPG",
    localNews:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/46lp6b1i_cover_6549.png",
    gala:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/g5o79ofx_IMG_3388.jpeg",
    rings:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/2cm5xadp_20240218_212924.jpg",
    montana:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/vevpadbs_Montana%20Morgan-600.jpg",
    morganJohnson:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/uwrhfft7_Morgan-Johnson-600.jpg",
    kidsDay:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/3p8oubc4_Kids%20day-600.jpg",
    motherSon:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/ye0gzrs8_IMG_4602.jpeg",
    newsStudio:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/edfd3m3p_IMG_0306.jpeg",
    henryFord1:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/nywt3lqp_IMG_3395.jpeg",
    jalenRose:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/pa6ywu35_IMG_3400.jpeg",
    detroitGala:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/c4xhv1ns_IMG_3401.jpeg",
    henryFord2:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/1hyzmyew_IMG_3433.jpg",
    fieldMentor:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/hxiyorta_MC225485.jpeg",
    bowling:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/mrnoc5wa_IMG_3622.jpeg",
    toyDriveShop:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/idqz4dsl_IMG_4553.jpeg",
    coffeeMentor:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/jtgo52dj_IMG_0464.jpeg",
    momGift:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/y0rylxfr_IMG_0472.jpeg",
    proclamation:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/iawj5n32_DSC00768.JPG",
    field1:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/ptbn3tmc_IMG_20240505_085920_635.JPG",
    field2:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/17hv3bg5_IMG_7177.JPG",
    fieldCutout:
      "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/troht5hj_IMG_7178%202.JPG",
  },
  // Location / Program partner logos
  partnerLogos: {
    ballmer: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/ijxybab6_BallmerGroup.png",
    unitedWay: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/05luk09p_United%20way.svg",
    chosenGenerations: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/wgqo0b51_Logo%20for%20Chosen.png",
    magChildCare: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/kdrp7fjf_1000006623.png",
    youngDetroiterSport: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/zigs3uer_1000006689%202.png",
    alWaliFlyer: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/e6mbxqgd_Al%20waili%204th%20Location.jpg",
    redRobin: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/6cage3hk_Redrobin.svg",
    boobli: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/biurr35b_2Boobli.svg",
    walmart: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/96sqkbf1_walmart.svg",
  },
  // Additional Semaj imagery
  additional: {
    michiganRoses: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/jqwsnvr0_IMG_3730%202.jpg",
    rings: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/2cm5xadp_20240218_212924.jpg",
    bigBrotherDay: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/issd89mx_IMG_7176.JPG.png",
    summerShirt: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/elo0tmck_1000006622.png",
  },
  // Stock imagery for gallery
  stock: {
    studentsCollab: "https://images.pexels.com/photos/8199220/pexels-photo-8199220.jpeg",
    mentor: "https://images.unsplash.com/photo-1547812563-b843ff353559?auto=format&fit=crop&w=1400&q=80",
    summerOutdoor: "https://images.unsplash.com/photo-1559131397-f94da358f7ca?auto=format&fit=crop&w=1400&q=80",
    volunteers: "https://images.unsplash.com/photo-1593113598332-cd288d649433?auto=format&fit=crop&w=1400&q=80",
    classroom: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1400&q=80",
    youthSports: "https://images.unsplash.com/photo-1551958219-acbc608c6377?auto=format&fit=crop&w=1400&q=80",
  },
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "DiscoverWorks™", href: "#summer" },
  { label: "About", href: "#about" },
  { label: "Programs", href: "#programs" },
  { label: "Board", href: "#board" },
  { label: "Gallery", href: "#gallery" },
  { label: "Partners", href: "#partners" },
  { label: "Get Involved", href: "#get-involved" },
  { label: "Donate", href: "#donate" },
];

export const BOARD_MEMBERS = [
  {
    name: "Semaj J. Morgan",
    role: "President, Treasurer & Director of General Operations",
    short: "President",
    photo: null,
  },
  {
    name: "Kimberly McLaurin",
    role: "Secretary",
    short: "Secretary",
    photo: null,
  },
  {
    name: "Darryl Bingham",
    role: "Director of Athletics & Student Relations",
    short: "Athletics & Student Relations",
    photo: null,
  },
  {
    name: "Elliott Oldham",
    role: "Director of Operations",
    short: "Operations",
    photo: null,
  },
  {
    name: "Donovan Jackson",
    role: "Director of Public Relations",
    short: "Public Relations",
    photo: null,
  },
  {
    name: "Erika Morgan",
    role: "Director of Legal Affairs",
    short: "Legal Affairs",
    photo: null,
  },
  {
    name: "Nefertiti Matthews",
    role: "Director of Character Development",
    short: "Character Development",
    photo: null,
  },
  {
    name: "Shelltoni Hunter",
    role: "Director of Human Resources",
    short: "Human Resources",
    photo: null,
  },
];

// Placeholder Official Sponsor slots — logos will be replaced with uploads.
export const SPONSORS = [
  { name: "Sponsor 1" },
  { name: "Sponsor 2" },
  { name: "Sponsor 3" },
  { name: "Sponsor 4" },
  { name: "Sponsor 5" },
  { name: "Sponsor 6" },
  { name: "Sponsor 7" },
  { name: "Sponsor 8" },
];

export const PARTNERS = [
  {
    name: "Ballmer Group",
    tag: "Main Program Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/ijxybab6_BallmerGroup.png",
    url: "https://www.ballmergroup.org/",
    featured: true,
  },
  {
    name: "United Way",
    tag: "Main Program Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/05luk09p_United%20way.svg",
    url: "https://unitedwaysem.org/",
    featured: true,
  },
  {
    name: "Walmart",
    tag: "Official Main Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/96sqkbf1_walmart.svg",
    url: "https://walmart.org/",
  },
  {
    name: "MAG Childcare & Learning Center",
    tag: "Location Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/kdrp7fjf_1000006623.png",
    url: "https://magchildcareandlearningcenter.org/",
  },
  {
    name: "Al Wali Montessori Center",
    tag: "Location Partner",
    url: "https://www.alwalicenter.com/",
  },
  {
    name: "Solid Foundations Tutoring",
    tag: "Location Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/vszngpoi_Silid%20Foundation.svg",
    url: "https://www.solidfoundationstutoring.org/",
  },
  {
    name: "Sweet Peas Early Childhood",
    tag: "Location Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/pn535vsi_logo%20design%20sweet.png",
  },
  {
    name: "Young Detroiter Sport",
    tag: "Community Partner",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/zigs3uer_1000006689%202.png",
  },
];

export const LOCATIONS = [
  {
    name: "MAG Childcare & Learning",
    address: "21999 Farmington Hills, MI 48336",
    grades: "Rising 1st, 2nd, 3rd & 4th",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/kdrp7fjf_1000006623.png",
    url: "https://magchildcareandlearningcenter.org/",
  },
  {
    name: "Solid Foundations",
    address: "31500 W. 13 Mile Rd., Farmington Hills 48334",
    grades: "Rising 9th & 10th",
    logo: "https://customer-assets.emergentagent.com/job_opportunity-awaits/artifacts/vszngpoi_Silid%20Foundation.svg",
    url: "https://www.solidfoundationstutoring.org/",
  },
];
